import { Icon, P } from '@fashionnovateam/nova-ui-toolkit';

export function ErrorWithIcon({ error }: { error: string }) {
  return (
    <P color="error" size="xs" weight="medium" className="flex items-center">
      <Icon.AlertCircle className="inline pr-1" />
      {error}
    </P>
  );
}
